import LetterAvatar from "@/components/Avatar/LetterAvatar"

export const columns = [
  {
    header: "sku",
    accessorKey: "sku",
  },
  {
    header: "Price",
    accessorKey: "cost_price",
  },
  {
    header: "Discount",
    accessorKey: "discount",
  },
  {
    header: "quantity",
    accessorKey: "quantity",
  },
  {
    header: "Total",
    accessorKey: "total",
  },
]
